import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';

import { MESSAGES } from '../../../../constants/messages';
import BuscaTypes from './types';

const INITIAL_STATE = {
  filtrosDinamicos: [],
  gridDinamico: [],
  protocolos: [],
  filtros: [],
  pendente_protocolo: 0,
  pendente_recepcao: 0,
  pendente_impeditivo: 0,
  error: false,
  loading: false,
  name: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BuscaTypes.CLEAR:
      return {
        ...INITIAL_STATE,
        filtrosDinamicos: state.filtrosDinamicos.map((el) => {
          el.value = '';
          return el;
        }),
        gridDinamico: state.gridDinamico 
      };
    case BuscaTypes.SEARCH_TOTAIS_REQUEST:
      return { ...state, loading: true, filtros: action.payload };

    case BuscaTypes.SEARCH_TOTAIS_SUCCESS:
      return {
        ...state,
        pendente_protocolo: action.payload.pendenteProtocolo,
        pendente_recepcao: action.payload.pendenteRecepcao,
        pendente_impeditivo: action.payload.pendenteImpeditivo,
        loading: true,
      };

    case BuscaTypes.SEARCH_REQUEST:
      return { ...state, loading: true, filtros: action.payload };

    case BuscaTypes.SEARCH_FAILURE:
      toast.error(MESSAGES.DEFAULT_ERROR_MESSAGE);
      return { ...state, loading: false, error: true };

    case BuscaTypes.SEARCH_SUCCESS: {
      const protocolos = action.payload;
      if (!protocolos.length) {
        toast.error(MESSAGES.EMPTY_ERROR_MESSAGE);
      }

      const checkProtocoloDuplicado = (protocolo) => ({ protocoloNumero }) => protocolo.protocoloNumero === protocoloNumero;

      const checkAllPendente = (itens) => Object.keys(itens).every((key) => itens[key].dataRecepcao === null);

      const unicos = protocolos.reduce((acc, item) => {
        const check = protocolos.filter(checkProtocoloDuplicado(item));

        if (check.length === 1) {
          return [...acc, item];
        }

        return acc;
      }, []);

      const multiplos = protocolos.reduce((acc, item) => {
        const check = protocolos.filter(checkProtocoloDuplicado(item));
        const checkAcc = acc.some(checkProtocoloDuplicado(item));

        /* Se todos os protocolos estiverem pendentes de recepção, ele pega o primeiro */
        if (!checkAcc && check.length > 1 && checkAllPendente(check)) {
          return [...acc, item];
        }

        if (!checkAcc && check.length > 1 && !!item.dataRecepcao) {
          return [...acc, item];
        }

        return acc;
      }, []);

      const protocolosFiltrados = [...unicos, ...multiplos];

      return {
        ...state,
        protocolos: protocolosFiltrados,
        loading: false,
        error: false,
      };
    }
    case BuscaTypes.LOAD_FILTER_REQUEST:
      return { ...state, loading: true };
    case BuscaTypes.LOAD_FILTER_FAILURE:
      return {
        ...state, data: [], loading: false, error: true,
      };
    case BuscaTypes.LOAD_FILTER_SUCESS:
      return {
        ...state, filtros: action.payload, loading: false, error: false,
      };
    case BuscaTypes.SEARCH_FILTERS_REQUEST:
      return {
        ...state, name: action.payload,
      };
    case BuscaTypes.SEARCH_FILTERS_SUCCESS:
      return {
        ...state,
        filtrosDinamicos: action.payload[0].filtros,
        gridDinamico: action.payload[0].grid,
      };
    default:
      return state;
  }
};
